import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FakeDataService } from 'src/app/_services/fake-data.service';

@Component({
  selector: 'app-send-notification',
  templateUrl: './send-notification.component.html',
  styleUrls: ['./send-notification.component.css']
})
export class SendNotificationComponent implements OnInit {
  email: string
  constructor(
    private fakeDataService: FakeDataService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {
  }

  sendOnline(){
    this.fakeDataService.testNotificationInApp(this.email).subscribe(res=>{
      this.toastrService.success('Sent')
    })
  }

  sendOffline(){
    this.fakeDataService.testNotificationPush(this.email).subscribe(res=>{
      this.toastrService.success('Sent')
    })
  }

}
